/**
 * Unidad de Fomento.
 */
export var CLF = {
  code: 'CLF',
  base: 10,
  exponent: 4
};